import React, { useEffect } from 'react';
import { EnTetePage, TitreSection } from '../components/charte/Elements';

const Section: React.FC<{ num: string; title: string; children: React.ReactNode }> = ({ num, title, children }) => (
  <section className="bloc">
    <TitreSection titre={<><span className="mono" style={{ marginRight: '10px', fontSize: '14px', color: 'var(--orange)' }}>{num}</span>{title}</>} />
    <div style={{ lineHeight: 1.7 }}>{children}</div>
  </section>
);

const Legal: React.FC = () => {
  useEffect(() => {
    document.title = 'Mentions légales — Tribe';
    return () => { document.title = 'Tribe — Portail client'; };
  }, []);

  return (
    <div className="page page--etroite">
      <EnTetePage surtitre="Portail client Tribe" titre="Mentions légales et confidentialité" />

        <div className="pile">

          <Section num="01" title="Éditeur">
            <p style={{ margin: 0 }}>
              <strong>NYSOM SAS</strong><br />
              Dakar, Sénégal<br />
              <a href="mailto:contact@tribe.sn">
                contact@tribe.sn
              </a>
            </p>
          </Section>

          <Section num="02" title="Hébergement">
            <p style={{ margin: 0 }}>
              <strong>Microsoft Azure</strong><br />
              Région : France Central (Paris)<br />
              Microsoft Corporation — One Microsoft Way, Redmond, WA 98052, USA
            </p>
          </Section>

          <Section num="03" title="Données collectées">
            <p style={{ margin: '0 0 10px' }}>
              Dans le cadre de l'utilisation du portail client Tribe, les données suivantes sont collectées :
            </p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Adresse email</li>
              <li>Nom et prénom</li>
              <li>Organisation / entreprise</li>
              <li>Géolocalisation des zones de collecte définies pour chaque mission</li>
            </ul>
            <p style={{ margin: '10px 0 0' }}>
              Ces données sont collectées uniquement dans le cadre de l'exécution des services Tribe et ne sont pas cédées à des tiers.
            </p>
          </Section>

          <Section num="04" title="Durée de conservation">
            <p style={{ margin: 0 }}>
              Les données personnelles sont conservées pendant une durée de{' '}
              <strong>3 ans</strong>{' '}
              à compter de la date de la dernière activité sur le compte.
              Passé ce délai, les données sont supprimées de manière sécurisée.
            </p>
          </Section>

          <Section num="05" title="Vos droits">
            <p style={{ margin: '0 0 10px' }}>
              Conformément à la réglementation applicable en matière de protection des données personnelles,
              vous disposez des droits suivants :
            </p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement (suppression du compte)</li>
            </ul>
            <p style={{ margin: '10px 0 0' }}>
              Pour exercer ces droits, contactez-nous à{' '}
              <a href="mailto:contact@tribe.sn">
                contact@tribe.sn
              </a>
              . Nous nous engageons à répondre dans un délai de 30 jours.
            </p>
          </Section>

          <Section num="06" title="Sécurité">
            <ul style={{ paddingLeft: '20px' }}>
              <li>Chiffrement des communications via <strong>TLS 1.2+</strong></li>
              <li>Mots de passe hashés avec <strong>BCrypt</strong> (aucun stockage en clair)</li>
              <li>Accès aux données restreint aux seuls membres habilités de l'équipe Tribe</li>
              <li>Hébergement sur infrastructure certifiée ISO 27001 (Microsoft Azure)</li>
            </ul>
          </Section>

        </div>

        <p className="petit texte-secondaire" style={{ marginTop: '28px', textAlign: 'center' }}>
          Dernière mise à jour : 9 avril 2026 · NYSOM SAS · contact@tribe.sn
        </p>
    </div>
  );
};

export default Legal;
